module.exports = __webpack_public_path__ + "static/media/included6.6292d59d.svg";